export default "__VITE_ASSET__sr07Z3Xb__"